<template>
  <div class="ad-campaign-details">
    <div class="ad-campaign-details-container">
      <div class="ad-campaign-details-h">
        <div class="ad-campaign-details-title">
          <span class="text">{{ $t("Campaigns.GoogleCampaignDetails.Title") }}</span>
        </div>
        <div class="ad-campaign-details-close" @click="emitToggleGoogleCampaignDetails2">
          <icon-base width="16" height="16" view-box="0 0 7 7" icon-name="times"><icon-times /></icon-base>
        </div>
      </div>
      <div v-if="googleCampaign" class="ad-campaign-details-b">
        <div class="addetails-title">{{ $t("Campaigns.GoogleCampaignDetails.Status") }}</div>
        <div class="campaign-status">
          <div class="campaign-name-status">
            <template v-if="googleCampaign.Status === 'Paused'">
              <span class="indicator indicator-4"></span>
            </template>
            <template v-else-if="googleCampaign.Status === 'Enabled'">
              <span class="indicator indicator-1"></span>
            </template>
            <template v-else-if="googleCampaign.Status === 'Unknown'">
              <span class="indicator indicator-5"></span>
            </template>
            <template v-else-if="googleCampaign.Status === 'Removed'">
              <span class="indicator indicator-3"></span>
            </template>
          </div>
          <div class="status-str-text">
            {{ googleCampaign.Status }}
          </div>
        </div>
        <div class="addetails-title">{{ $t("Campaigns.GoogleCampaignDetails.NameOfCampaign") }}</div>
        <div class="addetails-text">{{ googleCampaign.Name }}</div>
        <div class="addetails-subtitle">{{ $t("Campaigns.GoogleCampaignDetails.CampaignType") }}</div>
        <div class="addetails-text">
          {{ googleCampaign.CampaignType }}
        </div>
        <div class="addetails-subtitle">{{ $t("Campaigns.GoogleCampaignDetails.PrimaryStatus") }}</div>
        <div class="addetails-text">
          {{ googleCampaign.PrimaryStatus }}
        </div>

        <b-collapse :open="true" class="card addetails-card" animation="slide">
          <template #trigger="props">
            <div class="card-header" role="button">
              <p class="card-header-title">
                {{ $t("Campaigns.FacebookCampaignDetails.BudgetAndSchedule") }}
              </p>
              <a class="card-header-icon">
                <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon>
              </a>
            </div>
          </template>
          <div class="card-content">
            <div class="addetails-subtitle">{{ $t("Campaigns.FacebookCampaignDetails.Budget") }}</div>
            <div class="addetails-text">
              {{ $t("Campaigns.FacebookCampaignDetails.BudgetLifetime") }}
              {{ googleCampaign.BudgetTotal }}₪
            </div>
            <div class="addetails-text">
              {{ $t("Campaigns.FacebookCampaignDetails.BudgetDaily") }}
              {{ googleCampaign.BudgetDaily }}₪
            </div>
            <div class="addetails-subtitle">{{ $t("Campaigns.FacebookCampaignDetails.Schedule") }}</div>
            <div class="addetails-text">
              {{ formatDate(googleCampaign.StartDate) }}
            </div>
            <div class="addetails-text">
              {{ formatDate(googleCampaign.EndDate) }}
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
    <div class="ad-campaign-details-bg" @click="emitToggleGoogleCampaignDetails2"></div>
  </div>
</template>

<script lang="ts">
import moment from "moment";
import { Component, Prop, Vue } from "vue-property-decorator";
import { CampaignAdGridViewModel } from "@/models/campaigns/CampaignAdGridViewModel";
import { CampaignAdGroupGridViewModel } from "@/models/campaigns/CampaignAdGroupGridViewModel";
import { GoogleCampaign } from "@/models/campaigns/GoogleCampaign";
import GoogleApiService from "@/services/api/GoogleApiService";
import IconBase from "../IconBase.vue";
import IconCaretDown from "../icons/IconCaretDown.vue";
import IconTimes from "../icons/IconTimes.vue";

// const namespace = "campaignsModule";

@Component({
  components: {
    IconBase,
    IconCaretDown,
    IconTimes,
  },
})
export default class GoogleCampaignDetails extends Vue {
  @Prop() readonly adGroup!: CampaignAdGroupGridViewModel;
  @Prop() readonly ad!: CampaignAdGridViewModel;

  emitToggleGoogleCampaignDetails2(): void {
    this.$emit("toggle-google-campaign-details2");
  }

  //#region Vuex getters and actions

  //#endregion Vuex getters and actions

  //#region Properties

  googleCampaign: GoogleCampaign | null = null;

  //#endregion Properties

  //#region Watches

  //#endregion Watches

  //#region Getters

  //#endregion Getters

  //#region Lifecycle

  mounted(): void {
    GoogleApiService.getGoogleCampaign(this.adGroup.AdCampaignId)
      .then((result: GoogleCampaign) => {
        this.googleCampaign = result;
      })
      .finally(() => {
        // loader.hide();
      });
  }

  //#endregion Lifecycle

  //#region Handlers

  //#endregion Handlers

  //#region Private methods

  formatDate(date?: Date): string {
    if (!date) {
      return "";
    }
    return moment(date).format("DD/MM/YYYY HH:mm");
  }

  //#endregion Private methods
}
</script>

<style lang="scss">
@import "@/assets/styles/ad-campaign-details";
</style>
